export default __webpack_public_path__ + "static/media/profile1.50d9ef6f.png";